export default __webpack_public_path__ + "locales/sk/DeleteProfileEverDialog.json?hash=0fb21b8208ba67a6aae29e47d8e7e567";